var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMilestone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 60,
    viewBox: "0 0 57 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2546 38.3456C32.954 38.3456 36.7637 34.5359 36.7637 29.8365C36.7637 25.137 32.954 21.3274 28.2546 21.3274C23.5551 21.3274 19.7455 25.137 19.7455 29.8365C19.7455 34.5359 23.5551 38.3456 28.2546 38.3456Z",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87274 58.6363C14.5722 58.6363 18.3818 54.8267 18.3818 50.1273C18.3818 45.4278 14.5722 41.6182 9.87274 41.6182C5.1733 41.6182 1.36365 45.4278 1.36365 50.1273C1.36365 54.8267 5.1733 58.6363 9.87274 58.6363Z",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 29.7H44.7545C50.4 29.7 54.9545 34.2818 54.9545 39.9C54.9545 45.5454 50.3727 50.1 44.7545 50.1H19.5",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4727 18.3817C51.1722 18.3817 54.9818 14.5721 54.9818 9.87262C54.9818 5.17317 51.1722 1.36353 46.4727 1.36353C41.7733 1.36353 37.9636 5.17317 37.9636 9.87262C37.9636 14.5721 41.7733 18.3817 46.4727 18.3817Z",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0636 30.2999H11.5636C5.91819 30.2999 1.36365 25.7181 1.36365 20.0999C1.36365 14.4544 5.94547 9.8999 11.5636 9.8999H36.8455",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilestone);
export default __webpack_public_path__ + "static/media/milestone.7a739eee5307d5181244f2f0544d2125.svg";
export { ForwardRef as ReactComponent };